module.exports = __webpack_public_path__ + "static/media/gender-type.7de253fd.svg";